import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';
import { HttpErrorResponse } from '@angular/common/http';

enum ScipError {
  ErrorUnknown = 'SCIP_ERROR_UNKNOWN',
  InvalidParameter = 'SCIP_INVALID_PARAMETER',
  OrgNameAlreadyExist = 'SCIP_ORG_NAME_ALREADY_EXIST',
  OrgS2sKeyAlreadyExist = 'SCIP_ORG_S2S_KEY_ALREADY_EXIST',
  OrgEntityKeyAlreadyExist = 'SCIP_ORG_ENTITY_KEY_ALREADY_EXIST'
}

interface ScipBackendError {
  code: ScipError;
  message: string;
  timestamp: string;
}

enum MessageSeverity {
  Warning = 'warn',
  Error = 'error'
}

@Injectable({
  providedIn: 'root'
})
export class BackendErrorService {
  constructor(private notificationService: NotificationService) {}

  handleError(errorResponse: HttpErrorResponse, fallbackMsgKey = 'backendErrorService.msg.error.SCIP_ERROR_UNKNOWN'): void {
    this.createMessage(errorResponse, MessageSeverity.Error, fallbackMsgKey);
  }

  handleErrorWithInterpolation(errorResponse: HttpErrorResponse, msgKey: string, interpolationVar: Record<string, unknown>): void {
    this.createMessage(errorResponse, MessageSeverity.Error, msgKey, interpolationVar);
  }

  handleWarning(errorResponse: HttpErrorResponse, fallbackMsgKey = 'backendErrorService.msg.error.SCIP_ERROR_UNKNOWN'): void {
    this.createMessage(errorResponse, MessageSeverity.Warning, fallbackMsgKey);
  }

  private createMessage(errorResponse, severity: MessageSeverity, fallbackMsgKey: string, interpolationVar?: Record<string, unknown>) {
    const errorMsg = this.calculateMsgKey(errorResponse, fallbackMsgKey);

    if (severity === MessageSeverity.Error) {
      this.notificationService.showError(errorMsg, interpolationVar);
    } else if (severity === MessageSeverity.Warning) {
      this.notificationService.showWarning(errorMsg, interpolationVar);
    }
  }

  private calculateMsgKey(errorResponse: HttpErrorResponse, fallbackMsgKey: string): string {
    if (errorResponse?.error?.code && Object.values(ScipError).includes(errorResponse.error.code)) {
      return 'backendErrorService.msg.error.' + errorResponse.error.code;
    } else {
      return fallbackMsgKey;
    }
  }
}
